import Link from 'next/link';
import style from './header.module.scss';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { HeaderNavigation, HeaderState } from './header.state';
import dynamic from 'next/dynamic';
import { NavItem } from './nav-item/nav-item';
import { Themes } from '@layouts/main-layout/themes.enum';
import { useTranslations } from 'next-intl';
import Logo from 'public/assets/header/logo/gofinans-logo.svg';
import LogoMobile from 'public/assets/header/logo/gofinans-logo-mobile.svg';

const StartProjectModal = dynamic(
  () => import('../interactions/start-project/start-project.modal'),
);

interface HeaderProps {
  isMenuOpened: boolean;
  onMenuClicked: () => void;
  theme?: Themes;
}

const Header = ({ isMenuOpened, onMenuClicked, theme }: HeaderProps) => {
  const [isStartProjectModalOpened, setStartProjectModalOpened] = useState(false);
  const [viewingLink, setViewingLink] = useState<string>('');
  const t = useTranslations();
  const router = useRouter();

  useEffect(() => {
    setViewingLink('');
  }, [router.asPath]);

  const openStartProjectWindow = () => {
    setStartProjectModalOpened(true);
  };
  const { logo, logoMobile, darkModeLogo, darkModeLogoMobile, navigation } = HeaderState;

  const headerImg = theme === Themes.Dark ? darkModeLogo : logo;
  const headerMobileImg = theme === Themes.Dark ? darkModeLogoMobile : logoMobile;

  if (!theme) {
    theme = Themes.Default;
  }

  return (
    <>
      <header className={`${style.header} ${style[theme]}`}>
        <div className={`${style.container}`}>
          <div className={style.logo}>
            <Link href="/" className={style.header__logo__link}>
              <Logo />
            </Link>
          </div>
          <div className={style.logo_mobile}>
            <Link href="/" className={style.header__logo__link}>
              <LogoMobile />
            </Link>
          </div>
          <div className={`${style.flex} ${style.navigation}`}>
            {navigation.map((item: HeaderNavigation, index: number) => {
              if (!item.actionButton) {
                return (
                  <NavItem
                    setViewingLink={setViewingLink}
                    viewingLink={viewingLink}
                    theme={theme}
                    key={index}
                    item={item}
                  />
                );
              }
              return (
                <Link href={item.link} className='flex items-center ml-6 relative' key={item.name}>
                  <div className={`${style.icon_container} group flex items-center gap-2 cursor-pointer`}>
                    {item.Icon && <item.Icon className="w-5 h-5 filter-primary-800-hover" />}
                    <span className='text-primary-600 font-semibold group-hover:text-primary-800'>{t(item.name)}</span>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className={`${style.header__item}`}>
            {/* TODO: temporary hidden login and sign up */}
            {/* <div className={style.header__item__login}>Log in</div>
            <button className={`${style.button} ${isMenuOpened ? `${style.button_hidden}` : null}`}>
              Sign up
            </button> */}
            <div
              aria-label="burger menu button"
              className={
                isMenuOpened ? style.button__burger__block_active : style.button__burger__block
              }
              onClick={() => onMenuClicked()}
            >
              <div className={style.button__burger}></div>
            </div>
          </div>
        </div>
      </header>
      {/* ====== Modals ====== */}
      <StartProjectModal
        isOpen={isStartProjectModalOpened}
        onClose={() => setStartProjectModalOpened(false)}
      />
    </>
  );
};

export default Header;
